import React from "react";
import Step4Fees from "./Step4Fees";

const DRAFT_KEY = "onboarding_draft";
const loadStepData = (stepIndex) => {
    try {
        const raw = window.localStorage.getItem(DRAFT_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        return data.allFormData ? data.allFormData[stepIndex] : null;
    } catch {
        return null;
    }
};

const EditStep4Fees = ({
    onNext,
    onSkip,
    onBack,
    isSubmitting,
    readOnly,
    formData,
}) => {
    const resolvedFormData = formData || loadStepData(3);

    return (
        <Step4Fees
            formData={resolvedFormData}
            onNext={onNext}
            onSkip={onSkip}
            onBack={onBack}
            isSubmitting={isSubmitting}
            readOnly={readOnly}
        />
    );
};

export default EditStep4Fees;
